import { create } from "zustand"

import type { DocPeerData, DocPresenceKey } from "@productlane/lib"

import type { DocPeers } from "@/lib/doc-presence-peers"
import { applyPeer, removePeer } from "@/lib/doc-presence-peers"

interface DocPresenceState {
	docs: Partial<Record<DocPresenceKey, DocPeers>>
	setPeer: (data: DocPeerData) => void
	removePeer: (docKey: DocPresenceKey, socketId: string) => void
	clearDoc: (docKey: DocPresenceKey) => void
	clearAll: () => void
}

export const useDocPresenceState = create<DocPresenceState>()((set) => ({
	docs: {},
	setPeer: (data) =>
		set((state) => {
			const peers = state.docs[data.docKey] ?? {}
			const next = applyPeer(peers, data, Date.now())
			if (next === peers && state.docs[data.docKey]) return state
			return { docs: { ...state.docs, [data.docKey]: next } }
		}),
	removePeer: (docKey, socketId) =>
		set((state) => {
			const peers = state.docs[docKey]
			if (!peers) return state
			return { docs: { ...state.docs, [docKey]: removePeer(peers, socketId) } }
		}),
	clearDoc: (docKey) =>
		set((state) => {
			if (!state.docs[docKey]) return state
			const { [docKey]: _cleared, ...docs } = state.docs
			return { docs }
		}),
	clearAll: () => set({ docs: {} }),
}))
